import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-color-grey" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-color-grey" }, "提示：如果同一个开发者下，需要同时添加多个UDID，请最后一次创建用户时才选择重新构建APP，减少等待时间。", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: `${_ctx.accountUserItem.id ? '编辑' : '创建'}用户`,
    modelValue: _ctx.selfVisible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selfVisible) = $event)),
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    "custom-class": "dialog-width-small",
    center: "",
    top: "5vh",
    onClose: _ctx.handleClose,
    onOpen: _ctx.handleOpen
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          size: "default",
          onClick: _ctx.handleClose
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 取 消 ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "default",
          onClick: _ctx.handleSave
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确 定 ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        inline: false,
        "label-width": "130px",
        rules: _ctx.rules,
        model: _ctx.formData,
        ref: "ruleForm",
        size: "default"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "开发者账号",
            prop: "accountId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.accountId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.accountId) = $event)),
                placeholder: "请选择开发者账号",
                style: {"width":"100%"},
                onChange: _ctx.handleAccountIdChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      value: item.accountId
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createTextVNode(_toDisplayString(item.accountName) + "(" + _toDisplayString(item.accountId) + ") ", 1),
                          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.handleTips(item)), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "用户来源",
            prop: "dataChannel"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.dataChannel,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.dataChannel) = $event)),
                placeholder: "请选择用户来源",
                style: {"width":"100%"},
                onChange: _ctx.handleChangeSource
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SOURCE, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: '_' + index,
                      label: item.name,
                      value: item.code
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(_component_el_form_item, {
            label: "用户名称",
            prop: "userId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.userId,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.userId) = $event)),
                style: {"width":"100%"},
                filterable: "",
                remote: "",
                "value-key": "userId",
                "reserve-keyword": "",
                placeholder: "请输入用户名",
                "remote-method": _ctx.handleFuzzyQueryUser,
                loading: _ctx.fuzzyQueryUserLoading
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.userId,
                      label: `${item.name}${item.bbCode}`,
                      value: item.userId
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "remote-method", "loading"])
            ]),
            _: 1
          }, 512), [
            [_vShow, Boolean(_ctx.formData.dataChannel)]
          ]),
          _createVNode(_component_el_form_item, {
            label: "UDID",
            prop: "userUDID"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.userUDID,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.userUDID) = $event)),
                modelModifiers: { trim: true },
                maxlength: "200",
                placeholder: "请输入用户的UDID"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "重新构建App",
            prop: "isReBuild"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.formData.isReBuild,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.isReBuild) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.REBUILD_APP_LIST, (item) => {
                    return (_openBlock(), _createBlock(_component_el_radio, {
                      label: item.value,
                      key: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _hoisted_2
            ]),
            _: 1
          }),
          (_ctx.formData.isReBuild === _ctx.REBUILD_APP_ENUM.YES)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "选择构建的App",
                prop: "appCode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formData.appCode,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.appCode) = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appListOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.appCode,
                          label: `${item.appName}（${item.appCode}）`,
                          value: item.appCode
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onClose", "onOpen"]))
}